import dynamic from "next/dynamic";
import React from "react";
import { getStyles } from "../../../assets/js/utils/functions";
import AnimatedHeaderText from "../commons/animated-header-text";

const ContentScroller = dynamic(() => import("../commons/content-scroller"), { ssr: true });

const StoreLinksExtras = () => {
  return (
    <section className="body-padding body-y-padding hide-for-observer">
      <div className="container">
        {/* <h3 className="text-black heading-three font-bold">
          Not Convinced yet? <br /> <span className="text-page">There’s more!</span>
        </h3> */}
        <AnimatedHeaderText
          series={[
            ["Not", "convinced", "yet?"],
            ["There's", "more!"],
          ]}
        />
      </div>
      <div className="anim-fade-up" style={getStyles({ "--delay": "0.8s" })}>
        <ContentScroller list={extras} />
      </div>
    </section>
  );
};

const extras = [
  [
    {
      label: "Custom store links",
      emoji: "🔗",
    },
    {
      label: "Automatic SEO",
      emoji: "🔎",
    },
    {
      label: "Manage multiple product options",
      emoji: "👠",
    },
    {
      label: "Upload multiple products at once",
      emoji: "📦",
    },

    {
      label: "Add multiple whatsapp numbers",
      emoji: "💬",
    },
    {
      label: "Create discounts",
      emoji: "🎁",
    },
    {
      label: "Create coupons",
      emoji: "🎟️",
    },
    {
      label: "Configure how customers see your products",
      emoji: "⚙️",
    },
  ],
  [
    {
      label: "Link your social media profiles",
      emoji: "🎈",
    },
    {
      label: "Set prices for locations you deliver to",
      emoji: "🚚",
    },
    {
      label: "Set opening & closing hours",
      emoji: "⏰",
    },
    {
      label: "Links to single products",
      emoji: "👖",
    },
    {
      label: "Manage multiple stores from one account",
      emoji: "🛒",
    },
    {
      label: "Organize your products into categories",
      emoji: "🗂",
    },
    {
      label: "Add multiple store managers",
      emoji: "🤵🏽",
    },
  ],
  [
    {
      label: "Multiple currencies - coming soon",
      emoji: "💸",
    },
    {
      label: "Facebook Pixel - Coming soon",
      emoji: "📈",
    },
    {
      label: "Import products from Instagram - Coming soon",
      emoji: "🎩",
    },
    {
      label: "Advanced store customizations - coming soon",
      emoji: "🏗",
    },
    {
      label: "Gifs & Videos for products - coming soon",
      emoji: "📹",
    },
    {
      label: "Verification Badges - coming soon",
      emoji: "❇️",
    },
    {
      label: "Checkout to twitter & Instagram - coming soon",
      emoji: "📥",
    },
  ],
];

export default StoreLinksExtras;
